import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Modal, Flex, List, Button, Checkbox } from 'antd';
import { LockOutlined, TeamOutlined } from '@ant-design/icons';
import { debounce } from 'lodash';
import { useNavigate } from 'react-router-dom';
// import { useSocketAction } from '../../../hooks/useSocketAction';
import ApiService from '../../../API/apiService';
import { API_ENDPOINTS } from '../../../API/endpoints';
import { handleApiError } from '../../../utils/CommonFunctions';
// import { socketEvents } from '../../../Settings/socketEventName';

const BrowseChannelModal = ({ open, onCancel, getChannelListApi}) => {
  const navigate = useNavigate();
  // const { emitEvent } = useSocketAction();
  const inputRef = useRef(null);

  const [channelSearchText, setChannelSearchText] = useState("");
  const [hoverState, setHoverState] = useState("");
  const [channelsList, setChannelsList] = useState([]);
  const [filteredChannels, setFilteredChannels] = useState([]);
  const [loading, setLoading] = useState(false);


  const UserData = JSON.parse(localStorage.getItem("userData"));
  let rout=UserData?.domain || 'elsnertech'

  const getCurrentUserDetails = useState(() => {
      return JSON.parse(localStorage.getItem('current_userdata') || '{}');
    });

  useEffect(() => {
    if (open) {
      searchChannelApi("");
      setChannelSearchText("");
    }
  }, [open]);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [open]);

  const searchChannelApi = async (searchTerm) => {
    setLoading(true);
    const body = {
      searchTerm,
      userId: UserData?._id,
    };
    try {
      const response = await ApiService.post(
        API_ENDPOINTS.browseChannel,
        body
      );

      if (response?.data && response?.statusCode === 200) {
        const { channels } = response.data;
        setChannelsList(channels || []);
        setFilteredChannels(channels || []);
      }
    } catch (error) {
      console.error('Error searching channels:', error);
    } finally {
      setLoading(false);
    }
  };

  // const handleSearch = debounce((text) => {
  //   setChannelSearchText(text);
  //   searchChannelApi(text);
  // }, 600);
  const handleSearch = (text) => {
    setChannelSearchText(text);
    debouncedSearch(text);
  }

  const debouncedSearch = useMemo(() => {
    return debounce((text) => {
      searchChannelApi(text);
    }, 600); // Delay of 300ms
  }, []);

  const handleHideJoinedChange = (e) => {
    if (e.target.checked) {
      setFilteredChannels(channelsList.filter(
        channel => !channel.members?.some(member => member.id === UserData._id)
      ));
    } else {
      setFilteredChannels(channelsList);
    }
  };

  const addMemberChannel = async (channelId) => {
    setLoading(true);
    try {
    const body ={
          members: [UserData._id],
          auto_join: true
        }
      const response = await ApiService.put(
        `${API_ENDPOINTS.addMemberChannel}/${channelId}`,
        body
      );

      if (response?.data) {
        const members = response.data.data.members.map(item => item.id);
        // await emitEvent(socketEvents.ADD_MEMBER, {
        //   data: {
        //     senderId: getCurrentUserDetails?._id,
        //     receiverId: members,
        //     channelId
        //   }
        // });
        getChannelListApi();
        searchChannelApi("");
      }
    } catch (error) {
      handleApiError(error);    } finally {
      setLoading(false);
    }
  };

  const handleChannelView = (channelId) => {
    
    localStorage.setItem("current_id", channelId);
    // navigate(`/elsnertech/channels/${channelId}`);
    navigate(`/${rout}/channels/${channelId}`);
    
    onCancel();
  };


  return (
    <Modal
      title="Browse Channels"
      open={open}
      onCancel={onCancel}
      footer={null}
      className="ec-modal browse-channels-modal"
      width={600}
      style={{ top: 20 }}
      destroyOnClose
    >
      <Flex gap="small" className="ant-modal-subheader">
        <div className="search-container">
          <i className="fa-solid fa-magnifying-glass search-icon"></i>
          <input
            type="text"
            className="custom-search"
            placeholder="Search Channels"
            value={channelSearchText}
            ref={inputRef}
            onChange={(e) => handleSearch(e.target.value)}
          />
        </div>
      </Flex>

      <Flex justify="space-between" className="channel-details">
        <p>{filteredChannels.length} Results</p>
        <Checkbox onChange={handleHideJoinedChange}>Hide Joined</Checkbox>
      </Flex>

      <div className="info__body">
        <Flex vertical className="suggestion-list-container">
          <List
            className="suggestion-list"
            itemLayout="horizontal"
            dataSource={filteredChannels}
            renderItem={(item) => (
              <List.Item
                onMouseEnter={() => setHoverState(item._id)}
                className={hoverState === item._id ? "hoverClass" : ""}
              >
                <List.Item.Meta
                  avatar={item.isPrivate ? <LockOutlined /> : <TeamOutlined />}
                  title={<span className="title">{item.name}</span>}
                  description={
                    <Flex gap="small">
                      {item.joinedStatus && (
                        <span className="join-status">
                          <i className="fa-solid fa-check"></i> Joined
                        </span>
                      )}
                      <span className="channel-members">
                        <i className="fa-regular fa-user"></i> {item.members?.length || 0}
                      </span>
                    </Flex>
                  }
                />

                {item.members?.some(member => member.id === UserData._id) ? (
                  <Button
                    type="text"
                    className="view-btn"
                    onClick={() => handleChannelView(item._id)}
                  >
                    View
                  </Button>
                ) : (
                  <Button
                    type="text"
                    className="join-btn"
                    onClick={() => addMemberChannel(item._id)}
                  >
                    Join
                  </Button>
                )}
              </List.Item>
            )}
          />
        </Flex>
      </div>
    </Modal>
  );
};

export default BrowseChannelModal;